import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  useRequiredActivityGraphContext,
  ActivityGraphTab,
} from './ActivityGraphContext';
import { ActivityLogTab } from './tabs/ActivityLogTab';
import { EmailsTab } from './tabs/EmailsTab';
import { DocumentsTab } from './tabs/DocumentsTab';
import { cn } from '@/lib/utils';
import type { SystemEntity } from '@erp/shared-types';

interface ActivityGraphTabsProps {
  entityType: SystemEntity;
  entityId: string;
  conversationId?: string | null;
  className?: string;
}

export function ActivityGraphTabs({
  entityType,
  entityId,
  conversationId,
  className,
}: ActivityGraphTabsProps) {
  const { activeTab, setActiveTab } = useRequiredActivityGraphContext();

  return (
    <div className={cn('h-full flex flex-col min-h-0', className)}>
      <Tabs
        value={activeTab}
        onValueChange={(value) => setActiveTab(value as ActivityGraphTab)}
        className="h-full flex flex-col"
      >
        <div className="shrink-0">
          <TabsList className="w-full">
            <TabsTrigger value="activity">Activity</TabsTrigger>
            <TabsTrigger value="emails">Emails</TabsTrigger>
            <TabsTrigger value="documents">Documents</TabsTrigger>
          </TabsList>
        </div>

        <TabsContent
          value="activity"
          className="flex-1 min-h-0 overflow-auto mt-0"
        >
          <ActivityLogTab entityType={entityType} entityId={entityId} />
        </TabsContent>

        <TabsContent
          value="emails"
          className="flex-1 min-h-0 overflow-auto mt-0"
        >
          <EmailsTab conversationId={conversationId} />
        </TabsContent>

        <TabsContent
          value="documents"
          className="flex-1 min-h-0 overflow-auto mt-0"
        >
          <DocumentsTab conversationId={conversationId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
